import { hexToRgb } from "../utils/hexToRgb";

export const defaultTheme = {
  /**
   * black
   */
  primaryColor: "#1d1d1b",
  /**
   * light pink
   */
  secondaryColor: "#c1b4ae",
  /**
   *  of white
   */
  tertiaryColor: "#f0ece9"
} as const;

export const defaultThemeInRgb = {
  /**
   * black
   */
  primaryColor: hexToRgb(defaultTheme.primaryColor),
  /**
   * light pink
   */
  secondaryColor: hexToRgb(defaultTheme.secondaryColor),
  /**
   *  of white
   */
  tertiaryColor: hexToRgb(defaultTheme.tertiaryColor)
} as const;
